import React from "react";
import SEO from "../../common/SEO";
import Layout from "../../common/Layout";
import BreadcrumbOne from "../breadcrumb/BreadcrumbOne";
import SectionTitle from "../sectionTitle/SectionTitle";
// import PortfolioOne from "./PortfolioOne";
import DigitalPortfolioThreeColumn from "./DigitalPortfolioThreeColumn";
import FooterTwo from "../../common/footer/FooterTwo";
import Copyright from "../../common/footer/Copyright";

const DigitalPortfolio = () => {
  return (
    <>
      <SEO title="We are a 360 degree software solution provider." />

      <DigitalPortfolioThreeColumn />
      <FooterTwo />
      <Copyright />
    </>
  );
};
export default DigitalPortfolio;
